import { render, staticRenderFns } from "./ConfiguracoesModulosPage.vue?vue&type=template&id=92b27f9c&scoped=true"
import script from "./ConfiguracoesModulosPage.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesModulosPage.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracoesModulosPage.vue?vue&type=style&index=0&id=92b27f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b27f9c",
  null
  
)

export default component.exports